(() => {
  if (window.__mbProductMeasureScrollLoaded) return;
  window.__mbProductMeasureScrollLoaded = true;

  const TARGET_TEXT = 'tabla de medidas';
  const DESCRIPTION_SELECTOR = '[data-mb-product-description], .product-description-tab .product-description';

  const normalizeText = (value) =>
    String(value || '')
      .replace(/\u00a0/g, ' ')
      .replace(/\s+/g, ' ')
      .trim()
      .toLocaleLowerCase('es-AR');

  const findMeasureTarget = (description) => {
    const walker = document.createTreeWalker(
      description,
      NodeFilter.SHOW_TEXT,
      {
        acceptNode(node) {
          const parent = node.parentElement;
          if (!parent || parent.closest('script, style, noscript')) return NodeFilter.FILTER_REJECT;
          return normalizeText(node.nodeValue).includes(TARGET_TEXT)
            ? NodeFilter.FILTER_ACCEPT
            : NodeFilter.FILTER_SKIP;
        }
      }
    );

    const textNode = walker.nextNode();
    if (!textNode) return null;

    const parent = textNode.parentElement;
    if (!parent) return null;

    return parent.closest('h1, h2, h3, h4, h5, h6, p, li, tr, div') || parent;
  };

  const getHeaderOffset = () => {
    let offset = 0;

    document.querySelectorAll('header').forEach((header) => {
      const styles = window.getComputedStyle(header);
      if (styles.position !== 'fixed' && styles.position !== 'sticky') return;

      const rect = header.getBoundingClientRect();
      const isCoveringTop = rect.height > 0 && rect.bottom > 0 && rect.top <= 8;
      if (isCoveringTop) offset = Math.max(offset, rect.bottom);
    });

    return offset;
  };

  const scrollToTarget = (target) => {
    const headerOffset = getHeaderOffset();
    const viewportHeight = window.innerHeight || document.documentElement.clientHeight || 0;
    const availableHeight = Math.max(0, viewportHeight - headerOffset);

    // Keep "Tabla de medidas" comfortably inside the viewport instead of
    // pinning it immediately below the sticky header. This leaves the heading
    // and the beginning of the size table visible together.
    const desiredTargetY = headerOffset + (availableHeight * 0.34);
    const top = window.scrollY + target.getBoundingClientRect().top - desiredTargetY;
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    window.scrollTo({
      top: Math.max(0, top),
      behavior: reduceMotion ? 'auto' : 'smooth'
    });
  };

  const afterLayoutSettles = (callback) => {
    window.requestAnimationFrame(() => {
      window.requestAnimationFrame(callback);
    });
  };

  const getCollapseTrigger = (collapse) => {
    if (!collapse || !collapse.id) return null;

    return Array.from(document.querySelectorAll('[data-bs-toggle="collapse"]')).find(
      (trigger) => trigger.getAttribute('data-bs-target') === `#${collapse.id}`
    ) || null;
  };

  const openCollapseAndThen = (collapse, callback) => {
    if (!collapse || collapse.classList.contains('show')) {
      afterLayoutSettles(callback);
      return;
    }

    const trigger = getCollapseTrigger(collapse);
    let finished = false;
    let observer = null;

    const finish = () => {
      if (finished) return;
      finished = true;
      if (observer) observer.disconnect();
      afterLayoutSettles(callback);
    };

    collapse.addEventListener('shown.bs.collapse', finish, { once: true });

    observer = new MutationObserver(() => {
      if (collapse.classList.contains('show')) finish();
    });
    observer.observe(collapse, { attributes: true, attributeFilter: ['class'] });

    try {
      if (window.bootstrap && window.bootstrap.Collapse) {
        window.bootstrap.Collapse.getOrCreateInstance(collapse, { toggle: false }).show();
      } else if (trigger) {
        trigger.click();
      }
    } catch (error) {
      if (trigger) trigger.click();
    }

    window.setTimeout(() => {
      if (!collapse.classList.contains('show')) {
        collapse.classList.remove('collapsing');
        collapse.classList.add('collapse', 'show');
        collapse.style.height = '';
        if (trigger) {
          trigger.classList.remove('collapsed');
          trigger.setAttribute('aria-expanded', 'true');
        }
      }
      finish();
    }, 700);
  };

  const handleMeasureClick = (button) => {
    const description = document.querySelector(DESCRIPTION_SELECTOR);
    if (!description) return;

    const target = findMeasureTarget(description);
    const collapse = description.closest('.collapse');

    openCollapseAndThen(collapse, () => {
      // The target can only be measured accurately after the accordion is visible.
      const refreshedTarget = findMeasureTarget(description) || target || description;
      scrollToTarget(refreshedTarget);
    });
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-mb-measure-scroll]');
    if (!button) return;

    event.preventDefault();
    event.stopPropagation();
    handleMeasureClick(button);
  });
})();
